import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IconLanguage } from "@tabler/icons-react";
import { AppConstant, KeyConstant, LangConstant } from "const";
import { EventBusUtils, StorageUtils } from "utils";
import { PaperHeader } from "components";

const ChangeLanguageForm = () => {
  const { t: getLabel, i18n } = useTranslation(LangConstant.NS_COMMON);

  const languages = LangConstant.ARR_LANGUAGES;

  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);
  const [lang, setLang] = useState(currentLanguage);

  const handleChangeRadioInput = event => {
    setLang(event.target.value);
  };

  const handleSubmitLanguageForm = event => {
    event.preventDefault();
    StorageUtils.storePermanenceData(KeyConstant.KEY_LANGUAGE, lang);
    EventBusUtils.emit(AppConstant.EVENT_BUS_EVENTS.changeLocale);
  };

  useEffect(() => {
    setLang(i18n.language);
    setCurrentLanguage(i18n.language);
  }, [i18n.language]);

  return (
    <div>
      <div>
        <PaperHeader icon={<IconLanguage size={24} className="text-primary" />} title={getLabel(LangConstant.L_LANGUAGE)} />
        <form onSubmit={handleSubmitLanguageForm}>
          <div className="mb-3">
            {languages.map(language => (
              <label className="form-check" key={language.code}>
                <input
                  type="radio"
                  className="form-check-input"
                  name="language"
                  value={language.code}
                  checked={language.code === lang}
                  onChange={handleChangeRadioInput}
                />
                <span className="form-check-label">{getLabel(language.label)}</span>
              </label>
            ))}
          </div>
          <div className="text-center">
            <button
              className="btn btn-primary"
              type="submit"
              disabled={currentLanguage === lang}
              style={{ minWidth: "345px", minHeight: "46px" }}
            >
              {getLabel(LangConstant.L_SAVE_BUTTON)}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangeLanguageForm;
